// Imports
import axios from "axios";
import "../../../setup/config/apiConfig";

export const RESET = "RESET";
export const GET_PROPERTY_STATUSES = "GET_PROPERTY_STATUSES";
export const GET_PROPERTY_STATUSES_RESPONSE = "GET_PROPERTY_STATUSES_RESPONSE";
export const GET_PROPERTY_STATUSES_FAIL = "GET_PROPERTY_STATUSES_FAIL";

export function get(isLoading = true) {
  return (dispatch) => {
    dispatch({
      type: GET_PROPERTY_STATUSES,
      isLoading: isLoading,
    });
    return axios
      .get(`/propertystatus`)
      .then((response) => {
        dispatch({
          type: GET_PROPERTY_STATUSES_RESPONSE,
          propertyStatuses: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: GET_PROPERTY_STATUSES_FAIL,
          isLoading: false,
          error: error,
        });
      });
  };
}
